import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { DataSource } from '@angular/cdk/collections';
import {ServicesDeliveryService} from '@services/services-delivery.service';
import {UserService} from '@services/user.service';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {Carrier} from '@models/carrier.interface';
import {Product} from '@models/product.interface';
import 'rxjs/add/operator/map';

@Component({
  selector: 'carriers',
  templateUrl: './carriers.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  styleUrls: ['./carriers.component.scss']
})

export class CarriersComponent implements OnInit, OnDestroy {
  @Input() id: string;

  carriers: Array<Carrier> = [];
  inactiveProducts: Array<number>;
  userId: any;
  loading = true;
  // inactiveProductsForm: FormArray;

  carriersSubscription: Subscription;
  productsSubscription: Subscription;
  userIdSubscription: Subscription;
  inactiveProductsSubscription: Subscription;

  dataSource;
  displayedColumns: string[] = ['name', 'description', 'checkbox'];
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  expandedElement: any;

  constructor(
    private servicesDeliveryService: ServicesDeliveryService,
    private userService: UserService,
  ) {}

  ngOnInit() {

    this.userIdSubscription = this.userService.userId.subscribe(id => {
      this.userId = id;
      this.getInactiveProducts();
    });

    this.carriersSubscription = this.servicesDeliveryService.getServices()
      .subscribe(services => {
        this.carriers = services.data;
        this.productsSubscription = Observable.forkJoin(
          ...services.data.map(({id}) => this.servicesDeliveryService.getProductsByServiceId(id)),
        ).map((data: Product[][]) => this.carriers.map((carrier, index) => ({...carrier, products: data[index]})))
          .subscribe(data => {
            this.carriers = data;
            this.dataSource = new ExampleDataSource(this.carriers);
            this.loading = false;
          });
      });

  }

  ngOnDestroy() {
    this.carriersSubscription.unsubscribe();
    this.productsSubscription.unsubscribe();
    this.userIdSubscription.unsubscribe();
    this.inactiveProductsSubscription.unsubscribe();
  }

  getInactiveProducts() {
    this.inactiveProductsSubscription = this.userService.getUserInactiveProducts(this.userId)
      .subscribe(data => {
        this.inactiveProducts = data.products;
      });
  }

  handleProductChange({checked}, productId) {
    if (checked) {
      this.inactiveProducts = this.inactiveProducts.filter(id => id !== productId);
    } else {
      this.inactiveProducts.push(productId);
    }
  }

  handleCarrierChange(event, carrierId) {
    const {checked} = event;
    const carrier: Carrier = this.carriers.find(carrier => carrier.id === carrierId);
    const products: number[] = carrier && carrier.products.map((product) => product.id);
    if (!products) {
      return;
    }
    if (checked) {
      this.inactiveProducts = this.inactiveProducts.filter(productId => {
        return !(products.indexOf(productId) + 1);
      });

    } else {
      products.forEach(productId => {
        if (!(this.inactiveProducts.indexOf(productId) + 1)) {
          this.inactiveProducts.push(productId);
        }
      });
    }
  }

  isCarrierChecked(carrier) {
    const products: any[] = carrier && carrier.products.map((product) => product.id);
    return products.length && products.every(product => !(this.inactiveProducts.indexOf(product) + 1));
  }

  handleClick(event) {
    event.stopImmediatePropagation();
  }

  saveInactiveProducts() {
    this.loading = true;
    this.userService.setUserInactiveProducts(this.userId, this.inactiveProducts)
      .subscribe(data => {
        this.loading = false;
        this.getInactiveProducts();
      });
  }
}


export class ExampleDataSource extends DataSource<any> {
  carriers: Carrier[];
  constructor(carriers) {
    super();
    this.carriers = carriers;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Element[]> {
    const rows = [];
    this.carriers.forEach(element => rows.push(element, { detailRow: true, element }));
    return Observable.of(rows);
  }

  disconnect() { }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/carriers/carriers.component.ts